const { general } = require('./_general');

/**
 * I'm keeping all this seperate as it's part of the migration from using tables on quotes/jobs
 * to using modals and cards. This keeps it so I can switch it on and off easy.
 */
var quotesModal = {

    listen: function () {
        // Edit line modal open
        $(document).on('click', '[role="edit-door-modal"]', function(event) {
            quotesModal.openEditDoorModal(event, $(this)); 
        });
        

        // Handle form submission
        $(document).on('submit', '#editDoorForm,#editCavitySliderForm', function(event) {
            quotesModal.submitEditForm(event, $(this));
        });

        // Apply spec sheet defaults to every existing door/slider/cavity slider line
        $(document).on('click', '[role="apply-spec-sheet-to-all"]', function(event) {
            quotesModal.applySpecSheetToAllLines(event, $(this));
        });

        //editCavitySliderForm
    },

    openEditDoorModal: function(event, element) {
        event.preventDefault();

        var route = element.data('route');

        // We had to make it so customers can't see cost/margin etc at the bottom
        var customerMode = element.data('customermode');
        
        if (!route) {
            console.error('No route found on element');
            return;
        }
        
        // Show loading state on button
        const originalText = element.html();
        element.html('<i class="fas fa-spinner fa-spin me-2"></i>Loading...');
        element.prop('disabled', true);

        let data = {
            customerMode: customerMode ? '1' : '0',
        };

        $.post(route, data, function(response) {
            
            // Replace only the modal content, not the entire modal
            $('#editDoorModal .modal-content').html(response.markup);
            
            var modal = new window.bootstrap.Modal($('#editDoorModal')[0], {});
            general.initSelect2($("#editDoorModal"));
            
            // Add validation styling after select2 is initialized
            quotesModal.initSelectValidation('#editDoorModal');
            
            modal.show();
            
            // Reset button state
            element.html(originalText);
            element.prop('disabled', false);

        }, "json").fail(function(xhr, status, error) {
            console.error('Error loading modal:', error);
            alert('Error loading edit form. Please try again.');
            
            // Reset button state
            element.html(originalText);
            element.prop('disabled', false);
        });
    },
    
    initSelectValidation: function(container) {
        const containerEl = $(container);
        
        // Find all select elements within form-field containers
        containerEl.find('.form-field select').each(function() {
            const selectEl = $(this);
            const formField = selectEl.closest('.form-field');
            
            // Function to update validation state
            const updateValidation = () => {
                const hasValue = selectEl.val() && selectEl.val() !== '';
                formField.toggleClass('val-error', !hasValue);
            };
            
            // Initial check
            updateValidation();
            
            // Handle change events
            selectEl.on('select2:select select2:unselect', updateValidation);
        });
        
        // Clean up when modal closes
        containerEl.closest('.modal').on('hidden.bs.modal', function() {
            containerEl.find('select').off('select2:select select2:unselect');
            // Also clean up any error classes
            containerEl.find('.form-field').removeClass('val-error');
        });
    },

    submitEditForm: function(event, form) {
        event.preventDefault();

        var submitButton = form.find('button[type="submit"]');
        var originalButtonText = submitButton.html();
        let customerMode = form.data('customermode');
        
        // Show loading state on submit button
        submitButton.html('<i class="fas fa-spinner fa-spin me-2"></i>Saving...').prop('disabled', true);

        // Get form data
        var formData = form.serialize();
        var actionUrl = form.attr('action');

        $.ajax({
            url: actionUrl,
            type: 'POST',
            data: formData,
            dataType: 'json',
            success: function(response) {
                if (response.success) {
                    // Close the modal using Bootstrap 5 syntax with jQuery
                    var modal = window.bootstrap.Modal.getInstance($('#editDoorModal')[0]);
                    if (modal) {
                        modal.hide();
                    }
                    
                    
                    // Show success message
                    //quotesModal.showSuccessMessage(response.message || 'Line updated successfully');
                    
                    // Reload the specific card
                    quotesModal.reloadCard(response.line, customerMode, true);

                    // Update quote/job totals
                    Livewire.dispatch('update-quote-totals');
                    
                } 
                // else {
                //     quotesModal.showErrorMessage(response.message || 'Error updating line');
                // }
                
                // Reset button
                submitButton.html(originalButtonText).prop('disabled', false);

                // Init any new tooltips (i.e. incomplete pricing)
                general.initTooltips();

            },
            error: function(xhr, status, error) {
                console.error('Form submission error:', {xhr, status, error});
                
                var errorMessage = 'Error saving changes. Please try again.';
                
                // Handle validation errors
                if (xhr.status === 422 && xhr.responseJSON && xhr.responseJSON.errors) {
                    var errors = xhr.responseJSON.errors;
                    var errorList = Object.values(errors).flat();
                    errorMessage = errorList.join(', ');
                }
                
                // quotesModal.showErrorMessage(errorMessage);
                
                // Reset button
                submitButton.html(originalButtonText).prop('disabled', false);
            }
        });
    },


    applySpecSheetToAllLines: function(event, element) {
        event.preventDefault();

        var route = element.data('route');

        if (!route) {
            console.error('No route found on element');
            return;
        }

        var confirmed = confirm(
            'This will overwrite the spec sheet fields (pattern, hardware, glass, etc.) on every ' +
            'existing door, slider and cavity slider with the current spec sheet values. Any ' +
            'one-off customisations made on those fields will be lost. Continue?'
        );

        if (!confirmed) {
            return;
        }

        var originalText = element.html();
        element.html('<i class="fas fa-spinner fa-spin me-2"></i>Applying...');
        element.prop('disabled', true);

        $.post(route, {}, function(response) {

            // Reload each affected card using the same mechanism the edit modal uses
            (response.lines || []).forEach(function(line) {
                quotesModal.reloadCard(line, false, false);
            });

            Livewire.dispatch('update-quote-totals');

            element.html(originalText);
            element.prop('disabled', false);

        }, "json").fail(function(xhr, status, error) {
            console.error('Error applying spec sheet to all lines:', error);
            alert('Error applying spec sheet. Please try again.');

            element.html(originalText);
            element.prop('disabled', false);
        });
    },

    reloadCard: function(line, customerMode, animateCard = false) {
    
        // Find the actual card element for this specific line
        let card = $('.door-card[data-lineid="' + line.id + '"]');
        let mode = card.data("mode");

        if (card.length === 0) {
            // Fallback: reload the entire page if we can't find the specific card
            console.warn('Could not find card for line ID:', line.id);
            location.reload();
            return;
        }

        // Show loading state on the card
        card.addClass('opacity-50');
        
        // Make request to get updated card HTML
        let reloadUrl = '/'+mode+'/reload-card/' + line.id;
        let data = {
            customerMode: customerMode ? '1' : '0'
        };
        
        $.post(reloadUrl, data, function(response) {

            // Replace only the specific card with the new markup
            let newCard = $(response.markup);
            card.replaceWith(newCard);

            // Flash (and scroll to) the door card - find it in DOM to be safe
            if (animateCard) {
                let cardInDom = $('.door-card[data-lineid="' + line.id + '"]');
                general.flashCard(cardInDom);
            }

            // Init any new tooltips (i.e. incomplete pricing)
            general.initTooltips();

        }, "json");
    },

    showSuccessMessage: function(message) {
        // You can customize this based on your notification system
        if (typeof toastr !== 'undefined') {
            toastr.success(message);
        } else {
            // Fallback to simple alert or create a custom notification
            alert(message);
        }
    },

    showErrorMessage: function(message) {
        // You can customize this based on your notification system
        if (typeof toastr !== 'undefined') {
            toastr.error(message);
        } else {
            // Fallback to simple alert or create a custom notification
            alert('Error: ' + message);
        }
    }
};

// Initialize when DOM is ready
$(function () {
    quotesModal.listen();
});

module.exports = {
    quotesModal
};